import { render, staticRenderFns } from "./PatientIcon.vue?vue&type=template&id=1c2d6864&scoped=true&"
import script from "./PatientIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PatientIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d6864",
  null
  
)

export default component.exports